export default async function UserFetch(url: string, init?: RequestInit): Promise<Response> {
  const sessionId = document.cookie
    .split('; ')
    .find(cookie => cookie.startsWith('SessionId='))
    ?.split('=')[1];

  const pinit = {
    ...init,
    headers: {
      ...init?.headers,
      ...(sessionId ? { sessionId } : {})
    }
  };

  return fetch(url, pinit).then(response => {

    if (response.status === 401) {
      document.cookie = 'SessionId=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;';
      window.location.reload();
      return Promise.reject('Unauthorized');
    }

    return response;
  });
}

export async function UserPost(url: string, body: any, init?: RequestInit): Promise<Response> {
  return UserFetch(url, {
    ...init,
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
      ...init?.headers
    }
  });
}

export async function UserFetchJson(url: string, init?: RequestInit): Promise<any> {
  return UserFetch(url, init).then(async response => {
    if (response.ok) {
      return response.json();
    }
    // Surface the server's response body so endpoint-specific error messages
    // (e.g. "Owner 'X' has no API token configured") reach the UI instead of
    // being collapsed into a generic "Network response was not ok".
    const body = await response.text();
    throw new Error(body || `Request failed (${response.status} ${response.statusText})`);
  });
}

export async function UserPostJson(url: string, body: any, init?: RequestInit): Promise<any> {
  return UserPost(url, body, init).then(async response => {
    if (response.ok) {
      return response.json();
    }
    // Surface the server's response body so endpoint-specific error messages
    // (e.g. "Owner 'X' has no API token configured") reach the UI instead of
    // being collapsed into a generic "Network response was not ok".
    const body = await response.text();
    throw new Error(body || `Request failed (${response.status} ${response.statusText})`);
  });
}